import React from "react";

export const Error404PageConfig = {
  settings: {
    layout: {
      config: {
        header: {
          display: false,
        },
        rightSidebar: {
          display: false,
        },
        footer: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: "/errors/error-404",
      exact: true,
      component: React.lazy(() => import("./Error404Page")),
    },
  ],
};
